import { createFileRoute } from "@tanstack/react-router";
import Page, { seo } from "@/pages/services/vision-to-launch";
import { buildServiceHead } from "@/lib/service-seo";

export const Route = createFileRoute("/services/vision-to-launch")({
  head: () => buildServiceHead(seo),
  component: Page,
});
